<template>
  <div id="comments">
    <form novalidate class="md-layout" 
      @submit.prevent="validateComment" 
      style="margin: 10px 0 0 0;"
    >
      <md-card class="md-layout-item" style="margin: auto;">
        <!-- (windowWidth > 922 ? 'md-size-90' : 'md-size-80') + ' ' -->
        <md-card-header>
          <div id="leave-comment-or-suggestion" class="md-title" style="word-break: break-word;">
            {{ translate('your-comments') }}
          </div>
        </md-card-header>

        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
              <md-field :class="getValidationClass('name')">
                <label for="name"> {{ translate('name') }} </label>
                <md-input name="name" id="name" autocomplete="given-name" v-model="form.name" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.name.required"> {{ translate('name-required') }} </span>
                <span class="md-error" v-else-if="!$v.form.name.minlength">
                  {{ translate('name-min-length') }}
                </span>
              </md-field>
            </div>

            <div class="md-layout-item md-size-100">
              <md-field :class="getValidationClass('comment')">

                <label for="comment"> {{ translate('comment') }}</label>
                <md-textarea name="comment" id="comment" md-autogrow v-model="form.comment" :disabled="sending">
                </md-textarea>

                <span class="md-error" v-if="!$v.form.comment.required"> {{ translate('comment-required') }} </span>
                <span class="md-error" v-else-if="!$v.form.comment.maxlength">
                  {{ translate('max-length-comment') }}
                </span>
              </md-field>
            </div>
          </div>

        </md-card-content>

        <md-progress-bar md-mode="indeterminate" v-if="sending" />

        <!-- <TO-DO> CREATE A CHECKBOX OPTION TO MAKE COMMENT/SUGGESTION PRIVATE OR PUBLIC </TO-DO> -->
        <div id="public-or-private-checkbox">
          <md-checkbox v-model="form.isPrivate" value="1">
            {{ translate('make-private-or-public-comment') }}
            <md-tooltip md-direction="top">
              {{ translate('private-or-public-tooltip') }}
            </md-tooltip>
          </md-checkbox>
        </div>

        <md-card-actions>
          <md-button type="submit" class="md-primary" :disabled="sending" style="border: 2px dashed;">
            {{ translate('submit') }}
          </md-button>
        </md-card-actions>
      </md-card>

      <!-- <md-snackbar :md-active.sync="userSaved">The user {{ lastUser }} was saved with success!</md-snackbar> -->
    </form>
    <br>
    <br>
    <hr>
    <div id="list" v-if="commentsList && commentsList.length > 0">
      <h2> {{ translate('comments') }} </h2>
      <ul>
        <li v-for="comment of commentsList" style="word-break: break-all;">
          {{ translate('visitor-name') }}
          {{ comment.name }}
          <br>
          {{ translate('visitor-comment') }}
          {{ comment.comment }}
          <br>
          {{ translate('date') }}
          {{ new Date(comment.created_at).toLocaleString() }}
          <hr>
          <md-button class="md-icon-button" @click="like(comment)">
            {{ comment.likes }} <md-icon>thumb_up</md-icon>
            <md-tooltip md-direction="top">Like</md-tooltip>
          </md-button>
          <md-button class="md-icon-button" @click="dislike(comment)">
            {{ comment.dislikes }} <md-icon>thumb_down</md-icon>
            <md-tooltip md-direction="top">Dislike</md-tooltip>
          </md-button>
        </li>
      </ul>
    </div>

    <md-snackbar :md-position="position" :md-duration="isInfinity ? Infinity : duration" :md-active.sync="showSnackbar"
      md-persistent>

      <span> {{ afterUpdateMessage }}</span>

      <md-button class="md-primary" @click="showSnackbar = false">Ok</md-button>

    </md-snackbar>
  </div>
</template>

<script>

  import { validationMixin } from 'vuelidate'
  import {
    required,
    minLength,
    maxLength
  } from 'vuelidate/lib/validators'
  import airtable from '../assets/airtable.js'
  import { eventBus } from '../main.js'
  import mixins from '../assets/mixins.js'

  export default {
    name: 'comments',
    mixins: [validationMixin, mixins],
    mounted() {
      
      // this.$route.params.lang ? this.lang = this.$route.params.lang : null
      eventBus.$on('updateLanguage', this.setLang)

      airtable.getComments().then(result => {

        result.forEach(rec => {

          let toPush = {
            id: rec.id,
            ...rec.fields
          }
          this.commentsList.push(toPush)
        })

      })

      this.alreadyClicked = localStorage.getItem('alreadyClicked')

      // window.onresize = () => {
      //   this.windowWidth = window.innerWidth
      // }
    },
    data: () => ({
      commentsList: [],
      lang: null,
      form: {
        name: null,
        comment: null,
        isPrivate: null
      },
      commentSaved: false,
      sending: false,
      lastUser: null,

      // snack bar
      showSnackbar: false,
      position: 'left',
      duration: 4000,
      isInfinity: false,
      afterUpdateMessage: null,

      alreadyClicked: false,
      typeOfThumbs: null,

      windowWidth: window.innerWidth

    }),
    validations: {
      form: {
        name: {
          required,
          minLength: minLength(4)
        },
        comment: {
          required,
          maxLength: maxLength(530)
        }
      }
    },
    computed: {

     /* language() {
        if (this.lang) {
          return this.lang
        } else {
          this.checkLanguage()
        }
        return this.lang */
    },
    methods: {

      update(comment, type) {
        
        airtable.updateComment(comment)
          .then(res => {

            if (res === 'done') {
              if (this.language === 'pt') {

                if (type === 'like')
                  this.afterUpdateMessage = 'Like atualizado'
                else
                  this.afterUpdateMessage = 'Dislike atualizado'

              } else {

                if (type === 'like')
                  this.afterUpdateMessage = 'Like updated'
                else
                  this.afterUpdateMessage = 'Dislike updated'

              }
              this.showSnackbar = true

            }
          })
          .catch(err => {

            if (this.language === 'pt') {
              this.afterUpdateMessage = 'Algum erro'
            } else {
              this.afterUpdateMessage = 'Some error'
            }
            this.showSnackbar = true

          })
      },

      like(comment) {
        
        // if (!this.alreadyClicked && !localStorage.getItem('alreadyClicked')) {
          this.alreadyClicked = true
          this.typeOfThumbs = 'up'
          localStorage.setItem('alreadyClicked',true)
          // localStorage.setItem('typeOfThumbs',this.typeOfThumbs)
          comment.likes++
          this.update(comment, 'like')
        // } 
        // else if (this.typeOfThumbs === 'up' || localStorage.getItem('typeOfThumbs') === 'up') {
        //   comment.likes--
        //   this.update(comment, 'like')
        //   localStorage.removeItem('alreadyClicked')
        //   localStorage.removeItem('typeOfThumbs')
        //   this.typeOfThumbs = null
        //   this.alreadyClicked = false
        // }


      },

      dislike(comment) {
        // if (!this.alreadyClicked && !localStorage.getItem('alreadyClicked')) {
          this.alreadyClicked = true
          this.typeOfThumbs = 'down'
          localStorage.setItem('alreadyClicked',true)
          // localStorage.setItem('typeOfThumbs',this.typeOfThumbs)
          comment.dislikes++
          this.update(comment, 'dislike')
        // } 
        // else if (this.typeOfThumbs === 'down' || localStorage.getItem('typeOfThumbs') === 'down') {
        //   comment.dislikes--
        //   this.update(comment, 'dislike')
        //   localStorage.removeItem('alreadyClicked',false)
        //   localStorage.removeItem('typeOfThumbs',null)
        //   this.typeOfThumbs = null
        //   this.alreadyClicked = false
        // }
      },

      setLang(l) {
        this.lang = l
      },

      translate(section) {
        switch (section) {
          case 'date':
            if (this.language === 'pt')
              return 'Data:'
            else
              return 'Date:'

          case 'name':
            if (this.language === 'pt')
              return 'Nome'
            else
              return 'Name'

          case 'your-comments':
            if (this.language === 'pt')
              return 'Deixe seu comentário/sugestão'
            else
              return 'Leave your comment/suggestion'

          case 'name-required':
            if (this.language === 'pt')
              return 'Nome é obrigatório'
            else
              return 'Name is required'

          case 'name-min-length':
            if (this.language === 'pt')
              return 'Nome deve conter ao menos 4 letras'
            else
              return 'Name must contain at least 4 characters'

          case 'comment':
            if (this.language === 'pt')
              return 'Comentário'
            else
              return 'Comment'

          case 'comment-required':
            if (this.language === 'pt')
              return 'Comentário é obrigatório'
            else
              return 'Comment is required'

          case 'max-length-comment':
            if (this.language === 'pt')
              return 'Máximo de 530 caracters permitido'
            else
              return 'Max 530 characters allowed'

          case 'submit':
            if (this.language === 'pt')
              return 'Enviar'
            else
              return 'Submit'

          case 'comments':
            if (this.language === 'pt')
              return 'Comentários dos visitantes'
            else
              return 'Visitors comments'

          case 'visitor-name':
            if (this.language === 'pt')
              return 'Nome:'
            else
              return 'Name:'

          case 'visitor-comment':
            if (this.language === 'pt')
              return 'Comentário:'
            else
              return 'Comment:'

          case 'make-private-or-public-comment':
            if (this.language === 'pt')
              return 'Tornar comentário privado'
            else
              return 'Make private comment'

          case 'private-or-public-tooltip':
            if (this.language === 'pt')
              return 'Comentário privado não será visível ao público:'
            else
              return 'Private comment will not be visible to public:'

        }
      },

      getValidationClass(fieldName) {
        const field = this.$v.form[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },

      clearForm() {
        this.$v.$reset()
        this.form.name = null
        this.form.comment = null
      },

      validateComment() {

        this.$v.$touch()

        if (!this.$v.$invalid) {
          this.saveComment()
        }
      },

      saveComment() {
        this.sending = true

        airtable.createComment(this.form).then(res => {
          this.commentsList.push({
            id: res.id,
            ...res.fields
          })
        })

        this.commentSaved = true
        this.sending = false
        this.clearForm()

      }
    }
  }

</script>

<style scoped>
  .md-progress-bar {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
  }

  #public-or-private-checkbox {
    margin: 0 auto;
    width: 95%;
  }

  @media screen and (max-width: 550px) {

    #leave-comment-or-suggestion {
      font-size: 15px;
    }

    #public-or-private-checkbox {
      margin: 0% auto 10% auto;
      line-height: 16px;
      font-size: 12px;
    }

  }
</style>